import { useEffect } from 'react';
import { useToast } from '../context/ToastContext';

export const SWUpdatePrompt = () => {
  const { showToast } = useToast();
  useEffect(() => {
    const onUpdate = (e) => {
      const worker = e.detail?.worker;
      if (!worker) return;
      showToast('A new version is available.', 'info', {
        persistent: true,
        action: {
          label: 'Refresh',
          onClick: () => {
            try { worker.postMessage({ type: 'SKIP_WAITING' }); } catch (_) {
              window.location.reload();
            }
          },
        },
      });
    };
    window.addEventListener('sw-update-available', onUpdate);
    return () => window.removeEventListener('sw-update-available', onUpdate);
  }, [showToast]);
  return null;
};
